module.exports = __webpack_public_path__ + "02_bob_black.2652bbe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_bob_black.png
// module id = uAm4
// module chunks = 0